<!--footer section -->
<footer [class]="class">
	<div *ngIf="newsletter">
		<div class="container">
			<section class="small-section border-section border-top-0">
				<div class="row">
					<div class="col-lg-6">
						<div class="subscribe">
							<div>
								<h4>¡CONOCE TODO!</h4>
								<p>Las mejores ofertas, noticias y descuentos exclusivos para ti. </p>
							</div>
						</div>
					</div>
					<div class="col-lg-6">
						<form class="form-inline subscribe-form" action="https://pixelstrap.us19.list-manage.com/subscribe/post?u=5a128856334b598b395f1fc9b&amp;id=082f74cbda" target="_blank" method="post">
							<div class="form-group mx-sm-3">
								<input type="email" #name name="EMAIL" id="mce-EMAIL" class="form-control" placeholder="Vincula tu línea Mega móvil">
							</div>
							<a type="submit" href="https://registro.megamovil.mx/vinculatulinea/" target="_blank" class="btn btn-solid">REGÍSTRATE</a>
						</form>
					</div>
				</div>
			</section>
		</div>
	</div>
	<section class="section-b-space light-layout">
		<div class="container">
			<div class="row footer-theme partition-f">
				<div class="col-lg-4 col-md-6">
					<div class="footer-title footer-mobile-title">
						<h4 style="color: #fff;">Acerca de nosotros</h4>
					</div>
					<div class="footer-contant">
						<div class="footer-logo">
							<img [src]="themeLogo" class="footer-logo__img" alt="Mega móvil">
						</div>
						<div class="footer-social">
                            <ul>
                                <li>
                                    <a href="https://www.facebook.com/Megacable" target="_blank" rel="noopener noreferrer" aria-label="Facebook"><i class="fa fa-facebook" aria-hidden="true"></i></a>
                                </li>
                                <li>
                                    <a href="https://www.instagram.com/megacable/" target="_blank" rel="noopener noreferrer" aria-label="Instagram"><i class="fa fa-instagram" aria-hidden="true"></i></a>
                                </li>
                                <li>
                                    <a href="https://x.com/Megacable" target="_blank" rel="noopener noreferrer" aria-label="X"><i class="fa fa-twitter" aria-hidden="true"></i></a>
                                </li>
                                <li>
                                    <a href="https://www.youtube.com/@MEGAmx" target="_blank" rel="noopener noreferrer" aria-label="YouTube"><i class="fa fa-youtube" aria-hidden="true"></i></a>
                                </li>
                                <li>
                                    <a href="https://www.tiktok.com/@mega.mx" target="_blank" rel="noopener noreferrer" aria-label="TikTok">
                                        <svg class="social-icon" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 448 512" aria-hidden="true"><path d="M448 209.9a210.1 210.1 0 0 1-122.8-39.3v178.8A162.6 162.6 0 1 1 185 188.3v89.9a74.6 74.6 0 1 0 52.2 71.2V0h88a121.2 121.2 0 0 0 1.9 22.2 122.2 122.2 0 0 0 53.9 80.2 121.4 121.4 0 0 0 67 20.1z"/></svg>
                                    </a>
                                </li>
                                <li>
                                    <a href="https://mx.linkedin.com/company/empleosmegacableholdings" target="_blank" rel="noopener noreferrer" aria-label="LinkedIn"><i class="fa fa-linkedin" aria-hidden="true"></i></a>
                                </li>
                            </ul>
                        </div>
					</div>
				</div>
				<div class="col offset-xl-1">
					<div class="sub-title">
						<div class="footer-title">
                            <h4>Categorías</h4>
                        </div>
                        <div class="footer-contant">
                            <ul>
                                <li><a [routerLink]="['/']">Inicio</a></li>
                                <li><a [routerLink]="['/shop/collection/left/sidebar']">Productos</a></li>
                                <!-- <li><a [routerLink]="['/pages/listar-metodo-pago']">Formas de Pago</a></li> -->
                                <!-- <li><a href="'/shop/collection/left/sidebar'">Celulares</a></li>
                                <li><a href="'/shop/collection/left/sidebar'">Gadgets</a></li> -->
                            <!--<li><a href="javascript:void(0)">Kids Fashion</a></li>
                                <li><a href="javascript:void(0)">Featured</a></li>-->
                            </ul>
                        </div>
					</div>
				</div>
				<div class="col">
					<div class="sub-title">
						<div class="footer-title">
                            <h4>Legales</h4>
                        </div>
                        <div class="footer-contant">
                            <ul>
                                <li><a [routerLink]="['/pages/terminos-y-condiciones']">Términos y condiciones</a></li>
                                <li><a [routerLink]="['/pages/aviso']">Aviso de Privacidad</a></li>
                                <li><a [routerLink]="['/pages/condiciones-envio']">Políticas de envío</a></li>
                                <!--<li><a href="javascript:void(0)">Contacto</a></li>-->
                            </ul>
                        </div>
					</div>
				</div>
				<!-- <div class="col">
					<div class="sub-title">
						<div class="footer-title">
						    <h4>store information</h4>
						</div>
						<div class="footer-contant">
						    <ul class="contact-list">
						        <li><i class="fa fa-map-marker"></i>Multikart Demo Store, Demo store
						            India 345-659</li>
						        <li><i class="fa fa-phone"></i>Call Us: 123-456-7898</li>
						        <li><i class="fa fa-envelope-o"></i>Email Us: <a>Support@Fiot.com</a></li>
						        <li><i class="fa fa-fax"></i>Fax: 123456</li>
						    </ul>
						</div>
					</div>
				</div> -->
			</div>
		</div>
	</section>
	<div class="sub-footer">
		<div class="container">
			<div class="row">
                <div class="col-xl-5 col-md-5 col-sm-12">
                  <div class="footer-end">
                    <p><i class="fa fa-copyright" aria-hidden="true"></i>{{ today | date:'y'}} Copyright © Megacable 2026. Todos los derechos reservados.</p>
                  </div>
                </div>
                <div class="col-xl-6 col-md-6 col-sm-12">
                  <div class="payment-card-bottom">
                    <ul>
                      <li>
                        <a><img src="assets/images/icon/visa.png" alt="" style="width: 26px !important;"></a>
                      </li>
                      <li>
                        <a><img src="assets/images/icon/master.png" alt="" style="width: 26px !important;"></a>
                      </li>
                      <li>
                        <a><img src="assets/images/icon/amex.png" alt="" style="width: 26px !important;"></a>
                      </li>
					  <li>
						  <a href="javascript:void(0)">
							  <img src="assets/images/icon/carnet.png" alt="" style="width: 26px !important;">
						  </a>
					  </li>
                    </ul>
                  </div>
                </div>
            </div>
		</div>
	</div>
</footer>
<!--footer section end -->